import React, { useState } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";

const KITCHENS = [
  { src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_company-site-new/artifacts/effae9df60d16cf5_bcpeabody-tampa-bay-kitchen-remodel-island-01.jpg", alt: "Remodeled kitchen with dark island and white cabinetry, Tampa Bay", name: "bcpeabody-tampa-bay-kitchen-remodel-island-01.jpg" },
  { src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_company-site-new/artifacts/2e108beadb37ab18_bcpeabody-tampa-bay-kitchen-remodel-cabinetry-02.jpg", alt: "Kitchen remodel with white cabinetry and island seating, Tampa Bay", name: "bcpeabody-tampa-bay-kitchen-remodel-cabinetry-02.jpg" },
  { src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_company-site-new/artifacts/523d11fde1ce05c7_bcpeabody-tampa-bay-kitchen-remodel-window-03.jpg", alt: "Kitchen remodel with glass-front upper cabinets and window, Tampa Bay", name: "bcpeabody-tampa-bay-kitchen-remodel-window-03.jpg" },
  { src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_company-site-new/artifacts/601c8d730c2f585f_bcpeabody-tampa-bay-kitchen-remodel-island-04.jpg", alt: "Kitchen island with drawer base and wood floors, Tampa Bay", name: "bcpeabody-tampa-bay-kitchen-remodel-island-04.jpg" },
];

const BATHS = [
  { src: "/images/projects/bcpeabody-tampa-bay-travertine-bath-remodel-02.jpg", alt: "Bathroom remodel with travertine wainscot, pedestal sink and checkered stone floor, Tampa Bay", name: "bcpeabody-tampa-bay-travertine-bath-remodel-02.jpg" },
  { src: "/images/projects/bcpeabody-tampa-bay-curbless-travertine-shower-03.jpg", alt: "Curbless travertine walk-in shower with checkered accent strip and recessed niche, Tampa Bay", name: "bcpeabody-tampa-bay-curbless-travertine-shower-03.jpg" },
  { src: "/images/projects/bcpeabody-tampa-bay-checkerboard-tile-tub-04.jpg", alt: "Bathroom remodel with black and white checkerboard tile surround and soaking tub, Tampa Bay", name: "bcpeabody-tampa-bay-checkerboard-tile-tub-04.jpg" },
  { src: "/images/projects/bcpeabody-tampa-bay-checkerboard-tile-shower-niche-05.jpg", alt: "Checkerboard tile tub and shower with recessed niche, Tampa Bay", name: "bcpeabody-tampa-bay-checkerboard-tile-shower-niche-05.jpg" },
  { src: "/images/projects/bcpeabody-tampa-bathroom-remodel-curbless-shower-01.jpg", alt: "Bathroom remodel with curbless walk-in shower, frameless glass and hexagon mosaic floor, Tampa Bay", name: "bcpeabody-tampa-bathroom-remodel-curbless-shower-01.jpg" },
  { src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_company-site-new/artifacts/ee6e0e8d437bea3a_bcpeabody-tampa-bay-walk-in-shower-remodel-02.jpg", alt: "Walk-in tile shower with niche and accent band, Tampa Bay", name: "bcpeabody-tampa-bay-walk-in-shower-remodel-02.jpg" },
  { src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_company-site-new/artifacts/f432f61381e6062d_bcpeabody-tampa-bay-bathroom-vanity-remodel-03.jpg", alt: "Double vanity with granite top and linen tower, Tampa Bay", name: "bcpeabody-tampa-bay-bathroom-vanity-remodel-03.jpg" },
  { src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_company-site-new/artifacts/d1dce4c5d4aaa49c_bcpeabody-tampa-bay-freestanding-tub-05.jpg", alt: "Freestanding tub with floor-mounted tub filler, Tampa Bay", name: "bcpeabody-tampa-bay-freestanding-tub-05.jpg" },
  { src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_company-site-new/artifacts/c7f48552afe0a062_bcpeabody-tampa-bay-marble-bath-remodel-06.jpg", alt: "Marble bathroom remodel with glass shower, Tampa Bay", name: "bcpeabody-tampa-bay-marble-bath-remodel-06.jpg" },
  { src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_company-site-new/artifacts/7f552a88a1da91d4_bcpeabody-tampa-bay-bath-vanity-marble-07.jpg", alt: "Dark vanity with marble top and tile wainscot, Tampa Bay", name: "bcpeabody-tampa-bay-bath-vanity-marble-07.jpg" },
  { src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_company-site-new/artifacts/f0f1fb0f34c46fdf_bcpeabody-tampa-bay-marble-shower-niche-08.jpg", alt: "Marble subway tile shower with built-in niches, Tampa Bay", name: "bcpeabody-tampa-bay-marble-shower-niche-08.jpg" },
  { src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_company-site-new/artifacts/1e24a7c93745f56b_bcpeabody-tampa-bay-bathroom-basketweave-tile-09.jpg", alt: "Bathroom with marble tile and basketweave border, Tampa Bay", name: "bcpeabody-tampa-bay-bathroom-basketweave-tile-09.jpg" },
];

function Thumb({ img, onClick }) {
  const hasImg = Boolean(img.src);
  return (
    <button
      onClick={hasImg ? onClick : undefined}
      className="relative aspect-square overflow-hidden bg-ink/5 border border-ink/10 group"
      aria-label={img.alt}
    >
      {hasImg ? (
        <img src={img.src} alt={img.alt} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1200ms]" />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center p-3 text-center">
          <span className="text-[10px] tracking-[0.1em] uppercase text-ink/40 leading-snug">Photo coming<br/>{img.name.slice(0, 32)}…</span>
        </div>
      )}
    </button>
  );
}

export default function KitchenBathGallery() {
  const [tab, setTab] = useState("kitchens");
  const [lightbox, setLightbox] = useState(null);
  const items = tab === "kitchens" ? KITCHENS : BATHS;

  const openIdx = (i) => setLightbox(i);
  const close = () => setLightbox(null);
  const nav = (dir) => setLightbox((cur) => {
    if (cur === null) return cur;
    const next = (cur + dir + items.length) % items.length;
    // skip placeholders
    for (let i = 0; i < items.length; i++) {
      const idx = (next + i * dir + items.length) % items.length;
      if (items[idx].src) return idx;
    }
    return cur;
  });

  return (
    <section id="gallery" data-testid="kb-gallery" className="bg-cream-light py-20 md:py-24">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <h2 className="font-serif font-medium text-ink tracking-tight mb-8" style={{ fontSize: "clamp(26px, 3.2vw, 36px)" }}>
          Recent kitchens and baths
        </h2>

        <div className="inline-flex border border-ink/20 p-1 mb-8" role="tablist">
          <button
            data-testid="kb-tab-kitchens"
            onClick={() => setTab("kitchens")}
            className={`px-5 py-2 text-[12px] tracking-[0.12em] uppercase ${tab === "kitchens" ? "bg-ink text-cream-light" : "text-ink"}`}
          >
            Kitchens
          </button>
          <button
            data-testid="kb-tab-baths"
            onClick={() => setTab("baths")}
            className={`px-5 py-2 text-[12px] tracking-[0.12em] uppercase ${tab === "baths" ? "bg-ink text-cream-light" : "text-ink"}`}
          >
            Baths
          </button>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {items.map((img, i) => (
            <Thumb key={img.name} img={img} onClick={() => openIdx(i)} />
          ))}
        </div>
      </div>

      {lightbox !== null && items[lightbox].src && (
        <div
          className="fixed inset-0 z-[60] bg-ink/95 flex items-center justify-center p-4"
          onClick={close}
          role="dialog"
          data-testid="kb-lightbox"
        >
          <button onClick={close} className="absolute top-6 right-6 text-cream-light" aria-label="Close"><X size={28} /></button>
          <button onClick={(e) => { e.stopPropagation(); nav(-1); }} className="absolute left-4 md:left-10 text-cream-light p-2" aria-label="Previous"><ChevronLeft size={32} /></button>
          <img
            src={items[lightbox].src}
            alt={items[lightbox].alt}
            className="max-w-full max-h-[85vh] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
          <button onClick={(e) => { e.stopPropagation(); nav(1); }} className="absolute right-4 md:right-10 text-cream-light p-2" aria-label="Next"><ChevronRight size={32} /></button>
        </div>
      )}
    </section>
  );
}
